
export const DateShortcutEnum = {
    TODAY       : 1,
    YESTERDAY   : 2,
    THIS_WEEK   : 3,
    THIS_MONTH  : 4,
    PREORDER    : 5,
    THIS_YEAR   : 6,
    LAST_YEAR   : 7,
    LAST_WEEK   : 8,
    LAST_MONTH  : 9,
}

export const DateFilterButtons = {
    PREORDER    : [DateShortcutEnum.PREORDER, lang.preorder],
    TODAY       : [DateShortcutEnum.TODAY, lang.today],
    YESTERDAY   : [DateShortcutEnum.YESTERDAY, lang.yesterday],
    THIS_WEEK   : [DateShortcutEnum.THIS_WEEK, lang.this_week],
    LAST_WEEK   : [DateShortcutEnum.LAST_WEEK, lang.last_week],
    THIS_MONTH  : [DateShortcutEnum.THIS_MONTH, lang.this_month],
    LAST_MONTH  : [DateShortcutEnum.LAST_MONTH, lang.last_month],
    THIS_YEAR   : [DateShortcutEnum.THIS_YEAR, lang.this_year],
    LAST_YEAR   : [DateShortcutEnum.LAST_YEAR, lang.last_year],
}
